export class Item{

  constructor(public name:string, public amount:number) {


  }
}
